import type { Mission } from '../missions.ts'

export const hhs: Mission = {
  id: "hhs",
  name: "U.S. Department of Health and Human Services",
  short: "HHS",
  call: "Humans",
  kind: "department",
  url: "https://www.hhs.gov/",
  established: 1953,
  palette: {
    primary: "#0b4778",
    secondary: "#008480",
    accent: "#936f38",
  },
  colorSource: {
    kind: "site",
    url: "https://www.hhs.gov/",
  },
  motif: "eagle",
  mission: {
    text: "The mission of the U.S. Department of Health and Human Services (HHS) is to enhance the health and well-being of all Americans, by providing for effective health and human services and by fostering sound, sustained advances in the sciences underlying medicine, public health, and social services.",
    url: "https://www.hhs.gov/about/index.html",
  },
  fact: {
    text: "Created in 1953 as Health, Education, and Welfare, it became HHS on May 4, 1980, when Education became its own department.",
    url: "https://www.hhs.gov/about/historical-highlights/index.html",
  },
  seal: {
    file: "public/seals/hhs.svg",
    source: "https://commons.wikimedia.org/wiki/File:US_Department_of_Health_and_Human_Services_seal.svg",
  },
  identifier: {
    about: "https://www.hhs.gov/about/index.html",
    accessibility: "https://www.hhs.gov/web/section-508/index.html",
    foia: "https://www.hhs.gov/foia/index.html",
    noFear: "https://www.hhs.gov/about/agencies/asa/eeo/no-fear-act/index.html",
    oig: "https://oig.hhs.gov/",
    performance: "https://www.hhs.gov/about/strategic-plan/index.html",
    privacy: "https://www.hhs.gov/privacy/privacy-policy/index.html",
  },
  media: {
    photos: [
      {
        file: "/media/hhs-humphrey-building.jpg",
        small: "/media/hhs-humphrey-building-sm.jpg",
        alt: "The Hubert H. Humphrey Building, a modernist concrete office block at the foot of Capitol Hill, under a clear sky.",
        title: "Hubert H. Humphrey Building, Washington, D.C.",
        creator: "Carol M. Highsmith",
        source: "https://commons.wikimedia.org/wiki/File:Hubert_H._Humphrey_Building,_located_at_the_foot_of_Capitol_Hill,_Washington,_D.C_LCCN2013634632.jpg",
        license: "Public domain (Carol M. Highsmith Archive, Library of Congress)",
      },
      {
        file: "/media/hhs-heroic-shorepoints.jpg",
        small: "/media/hhs-heroic-shorepoints-sm.jpg",
        alt: "A red steel sculpture of angular blocks on the plaza in front of the Hubert H. Humphrey Building.",
        title: "Sculpture \"Heroic Shorepoints I\" at the Hubert H. Humphrey Building",
        creator: "Carol M. Highsmith",
        source: "https://commons.wikimedia.org/wiki/File:Sculpture_%22Heroic_Shorepoints_I%22_at_the_Hubert_Humphrey_Federal_Building,_Washington,_D.C_LCCN2010720625.tif",
        license: "Public domain (Carol M. Highsmith Archive, Library of Congress)",
      },
    ],
  },
}
